import { fetchWrapper, objectToQueryParams } from '../utils';

class adminBilling {
  static baseUrl = process.env.REACT_APP_BASE_API + 'admin/report/billing';

  // REPORTE DE FACTURACIÓN POR RUTA
  static async findByRouteAll(filters) {
    const url = `${this.baseUrl}/route?${objectToQueryParams(filters)}`;
    return await fetchWrapper.get(url);
  }

  static async downloadByRouteAll(filters) {
    const url = `${this.baseUrl}/route/download?${objectToQueryParams(filters)}`;
    return await fetchWrapper.get(url);
  }

  static async downloadByRouteOne(id) {
    const url = `${this.baseUrl}/route/${id}/download`;
    return await fetchWrapper.get(url);
  }

  // REPORTE RELACIÓN GENERAL DE PAGOS
  static async findByRelationAll(filters) {
    const url = `${this.baseUrl}/relation?${objectToQueryParams(filters)}`;
    return await fetchWrapper.get(url);
  }

  static async downloadByRelationAll(filters) {
    const url = `${this.baseUrl}/relation/download?${objectToQueryParams(filters)}`;
    return await fetchWrapper.get(url);
  }

  static async downloadByRelationOne(id) {
    const url = `${this.baseUrl}/relation/${id}/download`;
    return await fetchWrapper.get(url);
  }

  // REPORTE RELACIÓN GENERAL DE PAGOS
  static async findByProfitAll(filters) {
    const url = `${this.baseUrl}/profit?${objectToQueryParams(filters)}`;
    return await fetchWrapper.get(url);
  }

  static async downloadByProfitAll(filters) {
    const url = `${this.baseUrl}/profit/download?${objectToQueryParams(filters)}`;
    return await fetchWrapper.get(url);
  }

  static async downloadByProfitOne(id) {
    const url = `${this.baseUrl}/profit/${id}/download`;
    return await fetchWrapper.get(url);
  }

  // FACTURACIÓN POR TIPO DE PERSONA
  static async findAll(filters) {
    const url = `${this.baseUrl}?${objectToQueryParams(filters)}`;
    return await fetchWrapper.get(url);
  }

  static async downloadAll(filters) {
    const url = `${this.baseUrl}/download?${objectToQueryParams(filters)}`;
    return await fetchWrapper.get(url);
  }

  static async downloadOne(id) {
    const url = `${this.baseUrl}/${id}/download`;
    return await fetchWrapper.get(url);
  }
}

export class admin {
  static billing = adminBilling;
}

class moderatorFailures {
  static baseUrl = process.env.REACT_APP_BASE_API + 'moderator/reports/failures';

  static async findAll(filters) {
    const url = `${this.baseUrl}?${objectToQueryParams(filters)}`;
    return await fetchWrapper.get(url);
  }

  static async findOne(filters) {
    const url = `${this.baseUrl}/vehicle/${filters.plaque}?${objectToQueryParams(filters)}`;
    return await fetchWrapper.get(url);
  }

  static async getSelects() {
    const url = `${this.baseUrl}/selects`;
    return await fetchWrapper.get(url);
  }

  static async downloadAll(filters) {
    const url = `${this.baseUrl}/download?${objectToQueryParams(filters)}`;
    return await fetchWrapper.get(url);
  }

  static async downloadOne(id) {
    const url = `${this.baseUrl}/download/${id}`;
    return await fetchWrapper.get(url);
  }

  static async updateStatus(form) {
    const url = `${this.baseUrl}/status`;
    return await fetchWrapper.patch(url, form);
  }
}

class moderatorIncidents {
  static baseUrl = process.env.REACT_APP_BASE_API + 'moderator/reports/incidents';

  static async create(form) {
    return await fetchWrapper.post(this.baseUrl, form);
  }

  static async findAll(filters) {
    const url = `${this.baseUrl}?${objectToQueryParams(filters)}`;
    return await fetchWrapper.get(url);
  }

  static async findUsers(filters) {
    const url = `${this.baseUrl}/users?${objectToQueryParams(filters)}`;
    return await fetchWrapper.get(url);
  }

  static async findVehicles(filters) {
    const url = `${this.baseUrl}/vehicles?${objectToQueryParams(filters)}`;
    return await fetchWrapper.get(url);
  }

  static async getSelects() {
    const url = `${this.baseUrl}/selects`;
    return await fetchWrapper.get(url);
  }

  static async downloadOne(id) {
    const url = `${this.baseUrl}/download/${id}`;
    return await fetchWrapper.get(url);
  }
}

export class moderator {
  static failures = moderatorFailures;
  static incidents = moderatorIncidents;
}

class ownerFailures {
  static baseUrl = process.env.REACT_APP_BASE_API + 'owner/reports/failures';

  static async findAll(filters) {
    const url = `${this.baseUrl}?${objectToQueryParams(filters)}`;
    return await fetchWrapper.get(url);
  }

  static async findOne(filters) {
    const url = `${this.baseUrl}/vehicle/${filters.plaque}?${objectToQueryParams(filters)}`;
    return await fetchWrapper.get(url);
  }

  static async getSelects() {
    const url = `${this.baseUrl}/selects`;
    return await fetchWrapper.get(url);
  }

  static async downloadAll(filters) {
    const url = `${this.baseUrl}/download?${objectToQueryParams(filters)}`;
    return await fetchWrapper.get(url);
  }

  static async downloadOne(id) {
    const url = `${this.baseUrl}/download/${id}`;
    return await fetchWrapper.get(url);
  }
}

class ownerIncidents {
  static baseUrl = process.env.REACT_APP_BASE_API + 'owner/reports/incidents';

  static async create(form) {
    return await fetchWrapper.post(this.baseUrl, form);
  }

  static async findAll(filters) {
    const url = `${this.baseUrl}?${objectToQueryParams(filters)}`;
    return await fetchWrapper.get(url);
  }

  static async findUsers(filters) {
    const url = `${this.baseUrl}/users?${objectToQueryParams(filters)}`;
    return await fetchWrapper.get(url);
  }

  static async getSelects() {
    const url = `${this.baseUrl}/selects`;
    return await fetchWrapper.get(url);
  }

  static async downloadAll(filters) {
    const url = `${this.baseUrl}/download?${objectToQueryParams(filters)}`;
    return await fetchWrapper.get(url);
  }

  static async downloadOne(id) {
    const url = `${this.baseUrl}/download/${id}`;
    return await fetchWrapper.get(url);
  }
}

class ownerCommissions {
  static baseUrl = process.env.REACT_APP_BASE_API + 'owner/reports/commissions';

  static async findAll(filters) {
    const url = `${this.baseUrl}?${objectToQueryParams(filters)}`;
    return await fetchWrapper.get(url);
  }

  static async downloadAll(filters) {
    const url = `${this.baseUrl}/download?${objectToQueryParams(filters)}`;
    return await fetchWrapper.get(url);
  }

  static async downloadOne(id) {
    const url = `${this.baseUrl}/download/${id}`;
    return await fetchWrapper.get(url);
  }
}

export class owner {
  static failures = ownerFailures;
  static incidents = ownerIncidents;
  static commissions = ownerCommissions;
}
